<template>
  <div class="home">
    <b-container>
      <LiveDetect></LiveDetect>
    </b-container>
  </div>
</template>

<script>
import LiveDetect from '@/components/LiveDetect.vue';
export default {
  name: 'config',
  components: {
    LiveDetect
  }
}
</script>
